// RegExp we use throughout the application

// eslint-disable-next-line no-control-regex
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const START_ALPHA_NUMERIC_RE = /^[a-z\d]/i;
export const END_ALPHA_NUMERIC_RE = /[a-z\d]$/i;
export const ALPHA_NUMERIC_RE = /[a-z\d]/i;
export const NON_ALPHA_NUMERIC_RE = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\s]/;
export const ALL_HTML_TAGS = /<.+?>|<\/.+?>|&nbsp;/gi;
export const HTMLEndTags = /<\/(?:h1|h2|h3|p)+?>/gi;
